import React, { FC } from 'react';

import {
	REPORT_NOT_FOUND_POPUP_TEXT,
	REPORT_NOT_FOUND_POPUP_TITLE,
	REPORT_NOT_FOUND_STATE_KEY
} from 'src/apps/mobile-common/consts/MobileCommonConsts';
import { ReportNotFoundPopup } from 'src/common/components/report-not-found-popup/ReportNotFoundPopup';

export const MobileSdkSessionNotSyncedYetPopup: FC = () => {
	return (
		<ReportNotFoundPopup
			title={REPORT_NOT_FOUND_POPUP_TITLE}
			text={REPORT_NOT_FOUND_POPUP_TEXT}
			stateKey={REPORT_NOT_FOUND_STATE_KEY}
		/>
	);
};
